import loadable from '@loadable/component';

export default loadable(() =>
  import(/* webpackChunkName: "sidebar" */ './components/sidebar-desktop')
);
